import InternationalArrow from '@/assets/img/tmp/honors-club/international_arrow@2x.png';
import IntCouncilObj1 from '@/assets/img/tmp/honors-club/international_obj1@2x.png';
import IntCouncilObj2 from '@/assets/img/tmp/honors-club/international_obj2@2x.png';
import IntCouncilObj3 from '@/assets/img/tmp/honors-club/international_obj3@2x.png';
import IntCouncilObj4 from '@/assets/img/tmp/honors-club/international_obj4@2x.png';
import IntCouncilObj5 from '@/assets/img/tmp/honors-club/international_obj5@2x.png';
import IntCouncilObj6 from '@/assets/img/tmp/honors-club/international_obj6@2x.png';
import TopImg from '@/assets/img/tmp/honors-club/international_top_img@2x.png';
import JoinObj1 from '@/assets/img/tmp/honors-club/join_international_obj01@2x.png';
import JoinObj2 from '@/assets/img/tmp/honors-club/join_international_obj02@2x.png';
import JoinObj3 from '@/assets/img/tmp/honors-club/join_international_obj03@2x.png';
import JoinObj4 from '@/assets/img/tmp/honors-club/join_international_obj04@2x.png';
import JoinObj5 from '@/assets/img/tmp/honors-club/join_international_obj05@2x.png';
import Button, { BtnClose } from '@/components/Button';
import HonorsInquiryCard from '@/components/Card/HonorsInquiryCard';
import ContactUs from '@/components/ContactUs';
import Container from '@/components/Container';
import { PopCcontainer, PopupTitle } from '@/components/Css/Pop';
import FormGroup from '@/components/Form/FormGroup';
import Image from '@/components/Image';
import Modal from '@/components/Modal';
import { ProcessList } from '@/components/ProcessList';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import { NotiBox, NotiItem, NotiList } from '@/components/Text/TextNoti';
import { Tit, H4 } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { HonorsClubTabProps } from '@page-blocks/involve/individual/HonorsClubInterface';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import 'swiper/swiper.min.css';

const joinProcess = [
  {
    id: 1,
    title: `가입문의`,
    img: JoinObj1,
  },
  {
    id: 2,
    title: `맞춤형 사업 안내`,
    img: JoinObj2,
  },
  {
    id: 3,
    title: `후원확정`,
    img: JoinObj3,
  },
  {
    id: 4,
    title: `멤버십 서비스`,
    img: JoinObj4,
  },
  {
    id: 5,
    title: `결과보고`,
    img: JoinObj5,
  },
];

const qualification = [
  {
    id: 1,
    img: IntCouncilObj1,
    title: `유니세프 <br class="br_m" />펀드`,
    desc: [
      {
        id: 11,
        dec: `
          회원개인의 관심분야를 특화한<br class="br_pc" />
          UNICEF FUND를 생성합니다.
        `,
      },
    ],
  },
  {
    id: 2,
    img: IntCouncilObj2,
    title: `글로벌 파트너로 <br class="br_m" />자문가 역할`,
    desc: [
      {
        id: 21,
        dec: `
          자문그룹으로서 유니세프 리더십과의<br class="br_pc" />
          미팅을 하며 사업관련 의견을<br class="br_pc" />
          제시하고 반영합니다.
        `,
      },
    ],
  },
  {
    id: 3,
    img: IntCouncilObj3,
    title: `지원사업 현장방문`,
    desc: [
      {
        id: 31,
        dec: `
          사업현장방문을 통해 후원금이<br class="br_pc" />
          어떻게 사용되는지 확인할 수 있습니다.
        `,
      },
    ],
  },
  {
    id: 4,
    img: IntCouncilObj4,
    title: `글로벌 연례행사 초청`,
    desc: [
      {
        id: 41,
        dec: `
          유니세프 글로벌 행사 및<br class="br_pc" />
          인터내셔널 카운슬 심포지움에 초청합니다.
        `,
      },
    ],
  },
  {
    id: 5,
    img: IntCouncilObj5,
    title: `전 세계 회원들과의<br /> 강력한 네트워크`,
    desc: [
      {
        id: 51,
        dec: `
          전 세계 영향력있는 리더들과의 강력한<br class="br_pc" />
          네트워크 형성이 가능합니다.
        `,
      },
    ],
  },
  {
    id: 6,
    img: IntCouncilObj6,
    title: `유니세프 본부 및<br /> 한국위원회를 통한 홍보`,
    desc: [
      {
        id: 61,
        dec: `
          글로벌 경제지, 유니세프 홈페이지,<br class="br_pc" />
          보도자료, SNS등을 통해<br class="br_pc" />
          홍보할 수 있습니다.
        `,
      },
    ],
  },
];

const SectionTop = styled(Section)`
  padding-top: 96px;
  color: #fff;
  ${breakpoint(`tablet`)} {
    padding-top: 72px;
  }
  ${SectionHeader} {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;

    .col-dec {
      width: 59%;
      padding-right: 15px;

      p {
        margin-top: 32px;
        color: #fff;
      }

      ${breakpoint(`mobile`)} {
        .br_pc {
          display: none;
        }
        .tit_eng {
          ${Tit} {
            font-size: 18px;
          }
        }
      }
    }
    .col-img {
      margin-top: 17px;
    }
  }

  .img-wrap {
    margin-top: 200px;
  }
  .video-wrap {
    margin-top: 120px;
    width: 100%;
    max-width: 1120px;
    padding-top: 56.25%;
    position: relative;
    .video {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    ${breakpoint(`mobile`)} {
      margin-top: 60px;
    }
  }
  ${breakpoint(`tablet`)} {
    ${SectionHeader} {
      flex-wrap: wrap;

      .col-dec {
        width: 100%;
        margin-bottom: 32px;
      }

      .col-img {
        width: 100%;
        text-align: center;

        picture,
        img {
          width: 100%;
          max-width: 100%;
        }
      }
    }
    .img-wrap {
      margin-top: 180px;
    }
  }
`;

const SectionJoin = styled(Section)`
  margin-top: -1px;
  color: #fff;
  ol {
    ${breakpoint(`tablet`)} {
      row-gap: 50px;
    }
    .list-item {
      width: 20%;

      ${breakpoint(`tablet`)} {
        width: 50%;
        margin-bottom: 0;
        padding: 0 58px 0 10px;

        &:nth-child(2) {
          dt {
            &::after {
              display: block;
            }
          }
        }
      }
    }
    &.arrow {
      dt {
        &::after {
          width: 40px !important;
          height: 12px !important;
          background-image: url(${InternationalArrow}) !important;
          right: -16px !important;
          ${breakpoint(`tablet`)} {
            right: -58px !important;
            transform: translateY(-50%) !important;
          }
        }
      }
      dd {
        ${Tit} {
          color: #ffa136;
        }
      }
    }
  }

  ${NotiBox} {
    background: #46413c;
    padding: 30px;
    margin-top: 64px;
    margin-bottom: 0;
    ${breakpoint(`tablet`)} {
      width: calc(100% + 40px);
      margin-top: 32px;
      margin-left: -20px;
    }
  }
  ${NotiItem} {
    &::after {
      background: #ffa136;
    }
  }
`;

const SectionIntCouncil = styled(Section)`
  margin-top: -1px;
  color: #fff;
  .br_m {
    display: none;
  }
  .process-ol {
    row-gap: 64px;
    .list-item {
      width: 33%;

      dt {
        .img-wrap {
          height: 80px;

          .img-box {
            height: 100%;
            padding-top: 0;
            background-size: contain;
          }
          ${breakpoint(`tablet`)} {
            max-width: 100%;
          }
        }
      }
      dd {
        ${Tit} {
          color: #ffa136;
        }
      }
    }
  }
  ${breakpoint(`mobile`)} {
    padding: 60px 0;

    .br_m {
      display: block;
    }
    .br_pc {
      display: none;
    }
    ${SectionHeader} {
      padding-bottom: 46px;
    }
    .process-ol {
      row-gap: 44px;
      .list-item {
        width: 50%;
        padding: 0 10px;
        margin-bottom: 0;

        dt {
          .img-wrap {
            height: 40px;
            .img-box {
              padding-top: 40px;
            }
          }
        }
      }
    }
  }
`;

const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `고액후원팀`,
    tel: `02-721-5150~3`,
    email: `major@unicef.or.kr`,
  },
];

const brochureData = [
  {
    id: 1,
    title: `고액후원팀 소개서`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ob25vdXJzLWNsdWI=&dispFileNm=Philanthropy-Legacy.pdf&svrFileNm=Philanthropy-Legacy.pdf`,
  },
  {
    id: 2,
    title: `인터내셔널 카운슬`,
    link: `${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9ob25vdXJzLWNsdWI=&dispFileNm=250513_international-council-brochure.pdf&svrFileNm=250513_international-council-brochure.pdf`,
  },
];

const BrochureWrap = styled.div`
  padding: 120px 0;

  h4 {
    margin-bottom: 54px;
  }
  .btn-wrap {
    display: flex;
    gap: 30px;

    .col {
      flex: 1;
    }
  }
  ${breakpoint(`tablet`)} {
    padding: 60px 0;

    h4 {
      margin-bottom: 32px;
    }
    .btn-wrap {
      flex-direction: column;
      gap: 16px;
    }
  }

  ${Button} {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    ${breakpoint(`mobile`)} {
      padding: 15px 24px;
    }
  }
`;

const SectionInquiry = styled(Section)`
  .form-container {
    max-width: 736px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;

    ${FormGroup} {
      width: 50%;
      padding: 0 16px;
      margin-bottom: 24px;
      &.full {
        width: 100%;
      }
    }

    .chk-label {
      font-size: 14px;
    }
  }
  ${breakpoint(640)} {
    .form-container {
      max-width: auto;
      width: 100%;
      display: block;
      ${FormGroup} {
        width: 100%;
        padding: 0;
        margin-bottom: 16px;

        textarea {
          height: 140px;
        }
      }
    }
  }

  .btn-wrap {
    margin-top: 78px;
    text-align: center;

    .btn {
      width: 100%;
      max-width: 350px;
    }
  }

  .clear {
    display: block;
    width: 100%;
    height: 0;
    clear: both;
    visibility: hidden;
  }
`;
const ContactPopup = styled.div``;
const PopupContent = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 24px 0 50px;

  ${H4} {
    margin-bottom: 22px;
  }
  textarea {
    height: 140px;
  }
  .btn-wrap {
    margin-top: 34px;
    .btn {
      width: 100%;
    }
  }
`;
const FloatingBtn = styled(Button)`
  position: fixed;
  bottom: 50px;
  right: 100px;
  z-index: 100;
  width: 200px;
  background: #1cabe2;
  color: #fff;
  font-size: 18px;

  ${breakpoint(`tablet`)} {
    right: 20px;
  }
  ${breakpoint(`mobile`)} {
    .br_pc {
      display: none;
    }
    width: calc(100% - 40px);
    bottom: 30px;
    font-size: 16px;
  }
`;

const SectionContact = styled(Section)`
  background: #fff;
  color: #2d2926;
  padding-bottom: 240px !important;

  ${breakpoint(`tablet`)} {
    padding-bottom: 120px !important;
  }
`;
const honorTab = [
  {
    idx: 0,
    title: `아너스클럽 <em>(Honours Club)</em>`,
  },
  {
    idx: 1,
    title: `인터내셔널 카운슬 <em>(International Council)</em>`,
  },
];
const SectionTab = styled.div`
  height: 80px;
  border-bottom: 3px solid #c6c6c6;
  ${breakpoint(`mobile`)} {
    ${Container} {
      padding: 0;
    }
  }
`;
const TabButton = styled.li<{ active: boolean }>`
  cursor: pointer;
  width: 50%;
  height: 80px;
  line-height: 1.25;
  display: inline-flex;
  align-items: center;
  border-bottom: 3px solid #c6c6c6;
  border-color: ${(props) => (props.active ? `#1cabe2` : `#c6c6c6`)};
  color: ${(props) => (props.active ? `#1cabe2` : `#c6c6c6`)};
  transition: color 0.15s ease-in-out, border-color 0.15s ease-in-out;
  margin: 0;
  &:hover {
    border-color: #1cabe2;
    color: #1cabe2;
  }
  span {
    display: block;
    width: 100%;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    em {
      font-weight: 700;
    }
  }
  ${breakpoint(`mobile`)} {
    span {
      font-size: 16px;
      em {
        display: block;
      }
    }
  }
`;

const InternationalCouncil: React.FC<HonorsClubTabProps> = ({ location }) => {
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const [showFloatingBtn, setShowFloatingBtn] = useState(true);
  const [hasClosedPopup, setHasClosedPopup] = useState(false); // 팝업을 닫은 적이 있는지 기억
  const sectionRef = useRef(null); // SectionContact 감지
  const isInSectionRef = useRef(false); // 섹션 안/밖 상태 기억
  const targetRef = useRef<HTMLLIElement | null>(null);
  const [activeTab, setActiveTab] = useState(0);
  const { pathname, hash } = useMemo(() => location, [location]);

  useEffect(() => {
    if (hash === '#sectionInquiryIC') {
      setActiveTab(1);
    } else {
      setActiveTab(pathname.includes('international') ? 1 : 0);
    }
  }, [hash, pathname]);

  // 🎯 함께하는 분들 진입 시 Inquiry 모달 오픈
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        isInSectionRef.current = entry.isIntersecting;

        if (entry.isIntersecting) {
          if (!hasClosedPopup) {
            // 팝업을 닫은 적이 없다면 자동 열림
            setIsInquiryModalOpen(true);
            setShowFloatingBtn(false);
          }
        } else {
          setIsInquiryModalOpen(false);
          setShowFloatingBtn(true);
        }
      },
      { threshold: 0.1 },
    );

    const currentRef = sectionRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasClosedPopup]);

  // 팝업 닫기 핸들러
  const handleClosePopup = () => {
    setIsInquiryModalOpen(false);
    setShowFloatingBtn(true); // 팝업 닫으면 무조건 버튼 다시 표시
    setHasClosedPopup(true); // 팝업을 한 번 닫은 상태로 기록
  };

  return (
    <LayoutWithTitle
      // 강제로 breadcrumb 고정
      location={{
        ...location,
      }}
      paddingBtt
      title="고액·초고액후원"
      description="Unicef for every child"
    >
      <SectionTab>
        <Container>
          <ul className="flex">
            {honorTab.map(({ title, idx }) => (
              <TabButton
                ref={(ref) => {
                  if (activeTab === idx) {
                    targetRef.current = ref;
                  }
                }}
                active={activeTab === idx}
                key={idx}
                onClick={() => {
                  if (idx === 0) {
                    window.location.href = '/involve/individual/honors-club';
                  } else if (idx === 1) {
                    window.location.href =
                      '/involve/individual/international-council';
                  }
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </TabButton>
            ))}
          </ul>
        </Container>
      </SectionTab>
      <SectionTop backgroundColor="#3B342F">
        <Container>
          <SectionHeader className="with-desc">
            <div className="col-dec">
              <h2>
                <Tit size="s1">
                  세계에 특별한 가치를 전하는 <br />
                  리더들의 모임,
                </Tit>
              </h2>
              <h2 className="tit_eng">
                <Tit size="s2">
                  We invest in solutions. <br />
                  For children, for our future.
                </Tit>
              </h2>
              <p>
                <strong>유니세프 인터내셔널 카운슬</strong>은 전 세계 어린이의
                삶을 가장 직접적이고 <br className="br_pc" />
                임팩트 있게 변화시키는{' '}
                <strong>
                  100만 달러 이상 기부한 글로벌 초고액 후원자들의 모임
                </strong>
                입니다. <br />
                각 분야를 선도하는 이 영향력 있는 리더들은 후원자를 넘어
                아동권리를 위한 투자자로서 <br className="br_pc" />
                유니세프 사업에 깊이 참여하며, 세상을 바꾸는 가치로운 여정을
                함께하고 있습니다. <br />
                <strong>지금, 그 변화의 여정에 여러분을 초대합니다.</strong>
              </p>
            </div>
            <div className="col-img">
              <Image pcSrc={TopImg} mobileSrc={TopImg} />
            </div>
          </SectionHeader>
          <div className="video-wrap">
            <iframe
              className="video"
              src="https://www.youtube.com/embed/iI5rBsFpaJU?si=Yl2wb-qRIKIvbPD3"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Container>
      </SectionTop>

      {/* 가입방법 - 페이지 이동 */}
      <SectionJoin className="by-sub-main-layout" backgroundColor="#3B342F">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">유니세프 인터내셔널 카운슬 가입방법</Tit>
            </h2>
          </SectionHeader>
          <ProcessList itemData={joinProcess} arrow />
          <NotiBox>
            <NotiList>
              <NotiItem>
                일시후원 또는 누적 후원금액이 100만 달러 이상 개인후원자
              </NotiItem>
            </NotiList>
          </NotiBox>
        </Container>
      </SectionJoin>

      <SectionIntCouncil
        className="by-sub-main-layout"
        backgroundColor="#2D2926"
        ref={sectionRef}
      >
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">
                유니세프 <br className="br_m" />
                인터내셔널 카운슬이 되시면
              </Tit>
            </h2>
          </SectionHeader>
          <ProcessList itemData={qualification} />
        </Container>
      </SectionIntCouncil>

      <BrochureWrap>
        <Container>
          <h4>
            <Tit size="s2">브로셔 다운로드</Tit>
          </h4>
          <div className="btn-wrap">
            {brochureData.map((row) => (
              <div className="col" key={row.id}>
                <Button
                  ico="down"
                  outline
                  full
                  onClick={() => window.open(row.link)}
                >
                  <span className="ico">{row.title}</span>
                </Button>
              </div>
            ))}
          </div>
        </Container>
      </BrochureWrap>

      <SectionInquiry
        id="sectionInquiryIC"
        className="by-sub-main-layout"
        backgroundColor="#F8F9FB"
      >
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">인터내셔널 카운슬 문의</Tit>
            </h2>
          </SectionHeader>
          <HonorsInquiryCard formType="intl" onComplete={() => {}} />
        </Container>

        {showFloatingBtn && (
          <FloatingBtn
            onClick={() => {
              setIsInquiryModalOpen(true);
              setShowFloatingBtn(false); // 버튼 클릭 시 버튼 숨기기
            }}
          >
            인터내셔널 카운슬
            <br className="br_pc" /> 문의하기
          </FloatingBtn>
        )}
      </SectionInquiry>

      {isInquiryModalOpen && (
        <ContactPopup>
          <Modal
            maxWidth="480px"
            onRequestClose={() => {}}
            style={{ zIndex: `99` }}
          >
            <PopCcontainer>
              <PopupTitle>
                <h2>
                  <Tit size="s3" color="sky">
                    인터내셔널 카운슬 문의
                  </Tit>
                </h2>
                <BtnClose onClick={handleClosePopup}>
                  <span className="a11y">닫기</span>
                </BtnClose>
              </PopupTitle>
              <PopupContent className="inquiry-pop-content">
                <H4>
                  맞춤 안내를 위해 <br />
                  궁금하신 점을 문의해주세요!
                </H4>
                <HonorsInquiryCard
                  formType="intl"
                  onComplete={(isComplete) => {
                    if (isComplete === true) setIsInquiryModalOpen(false);
                  }}
                />
              </PopupContent>
            </PopCcontainer>
          </Modal>
        </ContactPopup>
      )}

      <SectionContact className="by-sub-main-layout">
        <Container>
          <ContactUs itemData={contactData} />
        </Container>
      </SectionContact>
    </LayoutWithTitle>
  );
};

export default InternationalCouncil;
